<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import ChannelIcon from 'next/icon/ChannelIcon.vue';
import SidebarUnreadBadge from './SidebarUnreadBadge.vue';
import { useChannelMultiSelect } from './useChannelMultiSelect';
import { getInboxIdentifier } from 'dashboard/helper/inbox';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  // eslint-disable-next-line vue/no-unused-properties
  active: {
    type: Boolean,
    default: false,
  },
  inbox: {
    type: Object,
    required: true,
  },
  badgeCount: {
    type: [Number, String],
    default: 0,
  },
});

const reauthorizationRequired = computed(() => {
  return props.inbox.reauthorization_required;
});

// Identificativo del canale (nostro @username Telegram, email intera, numero): distingue
// profili con lo stesso nome visualizzato (es. più account Telegram "Meridian").
const identifier = computed(() => getInboxIdentifier(props.inbox));

const { isSelectionMode, isSelected, toggleInbox } = useChannelMultiSelect();
</script>

<template>
  <!--
    In modalità selezione la checkbox prende il posto dell'icona del canale.
    Il click è gestito sullo <span> (stop + prevent) così non fa navigare la
    router-link che avvolge la leaf; l'input resta puramente visivo.
  -->
  <span
    v-if="isSelectionMode"
    class="size-4 grid place-content-center"
    @click.stop.prevent="toggleInbox(inbox.id)"
  >
    <input
      type="checkbox"
      tabindex="-1"
      :checked="isSelected(inbox.id)"
      class="size-3.5 cursor-pointer pointer-events-none accent-n-brand"
    />
  </span>
  <span v-else class="size-4 grid place-content-center rounded-full">
    <ChannelIcon :inbox="inbox" use-brand-icon class="size-4" />
  </span>
  <div class="flex-1 min-w-0">
    <div class="truncate">{{ label }}</div>
    <div
      v-if="identifier"
      :title="identifier"
      class="text-xs leading-tight truncate text-n-slate-10"
    >
      {{ identifier }}
    </div>
  </div>
  <SidebarUnreadBadge :count="badgeCount" />
  <div
    v-if="reauthorizationRequired"
    v-tooltip.top-end="$t('SIDEBAR.REAUTHORIZE')"
    class="grid place-content-center size-5 bg-n-ruby-5/60 rounded-full"
  >
    <Icon icon="i-woot-alert" class="size-3 text-n-ruby-9" />
  </div>
</template>
